import { render, staticRenderFns } from "./GoodsGalleryEditPage.vue?vue&type=template&id=2b72f085&scoped=true&"
import script from "./GoodsGalleryEditPage.vue?vue&type=script&lang=js&"
export * from "./GoodsGalleryEditPage.vue?vue&type=script&lang=js&"
import style0 from "./GoodsGalleryEditPage.vue?vue&type=style&index=0&id=2b72f085&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b72f085",
  null
  
)

export default component.exports